export default [
	// 1. 下载卫星地图
	{
		name: 'downloadMap',
		base: {
			url: '/Map/satellite/download',
			method: 'post',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	// 2. 查询任务状态
	{
		name: 'getDownloadStatus',
		base: {
			// /satellite/download/status/{taskId}
			url: '/Map/satellite/download/status/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	// 3. 下载文件
	{
		name: 'downloadFile',
		base: {
			// /files/{taskId}/{fileName}
			url: '/Map/files/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	// 4. 下载ZIP压缩包
	{
		name: 'downloadFileZip',
		base: {
			// /task/{taskId}/download-zip
			url: '/Map/task/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	// 5. 取消下载任务
	{
		name: 'cancelDownloadFile',
		base: {
			// /satellite/download/cancel/{taskId}
			url: '/Map/satellite/download/cancel/',
			method: 'post',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	// 6. 坐标转换
	{
		name: 'coordinateChange',
		base: {
			url: '/Map/coordinate/gcj02-wgs84-convert',
			method: 'post',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	// 7. 获取瓦片服务器列表
	{
		name: 'getSatelliteTileServers',
		base: {
			url: '/Map/satellite/tile-servers',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},

]